export const small = 'small';
export const normal = 'normal';
export const large = 'large';
export const getRef = size => ({
  small: 'Small',
  normal: '',
  large: 'Large'
})[size] || '';
//# sourceMappingURL=sizes.js.map